import {message} from 'ant-design-vue'
import axios from 'axios'
import router from "@/router/index";

const baseRequestUrl = 'https://pms.suanju.net/api';
// const baseRequestUrl = 'http://116.62.156.224:7686';//线上测试
// const baseRequestUrl = 'http://172.16.32.37:8000'; // 春莹内部测试

const service = axios.create({
    baseURL: baseRequestUrl,
    timeout: 300000
})


service.interceptors.request.use(
    config => {
        if (config.url == '/h5/login/sms' || config.url == '/h5/login/account' || config.url == '/h5/login/loginSend' || config.url == '/h5/login/qrcode' || config.url == '/h5/login/checkCode') {
            config.headers = {
                'version': "1.0.0",
                'source': '1'
            }
        } else {
            config.url = config.url + (sessionStorage.getItem("landlordInfo") ? ("?info=" + JSON.parse(sessionStorage.getItem("landlordInfo")).info) : "")
            config.headers = {
                'token': JSON.parse(sessionStorage.getItem("landlordInfo")).token,
                'version': "1.0.0",
                'source': '1'
            }
        }
        return config
    }
)

service.interceptors.response.use(response => {

    if (response.data.code == 0) {
        return Promise.resolve(response.data)
    } else if (response.data.code == 2) {
        sessionStorage.removeItem("landlordInfo")
        sessionStorage.removeItem("companyInfo");
        router.replace({
            path: "/",
            params: {
                redirect: "1"
            }
        });
    } else {
        message.error(response.data.msg)
        return Promise.reject(response.data)
    }
})

export default service
